import React, { useState, useContext } from "react";
import { Context } from "./context/TestContext";
import { Container, Row, Col, Button, Form, InputGroup, Card } from 'react-bootstrap';
import { FacebookShareButton, FacebookIcon, WhatsappShareButton, WhatsappIcon, } from "react-share";

import "./assets/estilos.css"


const Formulario = () => {
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [checkEmail, setCheckEmail] = useState("");
    const accion = "toc";
    const [finalizado, setFinalizado] = useState(false);
    const { puntaje, onResetPuntaje } = useContext(Context);
    const shareUrl = "https://web.cetep.cl/toc/"


    const enviarForm = async () => {
        const informacion = { accion, name, lastName, email, puntaje };

        const cargaUtil = JSON.stringify(informacion);

        const respuesta = await fetch(`../../controllers/informes.php`, {
            method: "POST",
            body: cargaUtil,
        });

        if (respuesta) {
            console.log("enviado");
            setFinalizado(true);
        }
    }

    return (
        <>   {(!finalizado) ?
            <Container>

                <Row>
                    <Col>
                        <div className="contenedorElemento">
                            <Card>
                                <Card.Img variant="top" src="./img/premio.jpg" />
                                <Card.Body>
                                    <Card.Title><h2>Regístrate y podrás participar en el sorteo de una Super Box de Bienestar Biku.</h2></Card.Title>
                                    <Form noValidate>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="6" controlId="validationCustom01">
                                                <Form.Label>Nombre</Form.Label>
                                                <Form.Control
                                                    required
                                                    type="text"
                                                    placeholder="Nombre"
                                                    defaultValue=""
                                                    onChange={evt => setName(evt.target.value)}
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                <Form.Control.Feedback type="invalid">
                                                    Ingrese su nombre.
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group as={Col} md="6" controlId="validationCustom02">
                                                <Form.Label>Apellido</Form.Label>
                                                <Form.Control
                                                    required
                                                    type="text"
                                                    placeholder="Apellido"
                                                    defaultValue=""
                                                    onChange={evt => setLastName(evt.target.value)}
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                <Form.Control.Feedback type="invalid">
                                                    Ingrese su apellido.
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group as={Col} md="6" controlId="email">
                                                <Form.Label>Email</Form.Label>
                                                <InputGroup hasValidation>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Email"
                                                        aria-describedby="inputGroupPrepend"
                                                        required
                                                        onChange={evt => setEmail(evt.target.value)}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingrese su email.
                                                    </Form.Control.Feedback>
                                                </InputGroup>
                                            </Form.Group>
                                            <Form.Group as={Col} md="6" controlId="validationCustom04">
                                                <Form.Label>Check Email</Form.Label>
                                                <InputGroup hasValidation>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Reingresar Email"
                                                        aria-describedby="inputGroupPrepend"
                                                        required
                                                        onChange={evt => setCheckEmail(evt.target.value)}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingrese nuevamente su email.
                                                    </Form.Control.Feedback>
                                                </InputGroup>
                                            </Form.Group>
                                            <Form.Group as={Col} md="6" controlId="accion">
                                                <Form.Control
                                                    required
                                                    type="hidden"
                                                    placeholder="accion"
                                                    defaultValue="toc"
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                <Form.Control.Feedback type="invalid">
                                                    Ingrese su nombre.
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                    </Form>
                                    {
                                        ((name !== "" && lastName !== "" && email !== "" && checkEmail !== "") && (email == checkEmail)) ?
                                            <Button variant="success" className="botonParticipar" onClick={enviarForm} >Participar</Button> :
                                            <Button disabled variant="danger" className="botonParticipar" >Debe ingresar sus datos</Button>
                                    }
                                </Card.Body>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </Container>
            :
            <Container>
                <Row>

                    <Col>
                        <div className="contenedorElemento">
                            <Card>
                                <Card.Img variant="top" src="./img/premio.jpg" />
                                <Card.Body>
                                    
                                    <Card.Title><h2 className="shareTitle">Comparte este test con tus amigos.</h2></Card.Title>
                                    <ul className="shareContent">
                                        <li>
                                            <FacebookShareButton url={shareUrl}>
                                                <FacebookIcon size={62} round={true} />
                                            </FacebookShareButton>
                                        </li>
                                        <l1>
                                            <WhatsappShareButton url={shareUrl}>
                                                <WhatsappIcon size={62} round={true} />
                                            </WhatsappShareButton>
                                        </l1>
                                    </ul>
                                    <Button onClick={onResetPuntaje} className="botonParticipar">Volver a realizar test</Button> <br />
                                </Card.Body>
                            </Card>

                        </div>
                    </Col>
                </Row>
            </Container>
        }
        </>
    );
}

export default Formulario;